import React, { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * Legacy register route with referral - redirects to new route
 * @deprecated Use /auth/register/[pid] instead
 */
const RegisterRefPage: React.FC = () => {
    const router = useRouter();
    const { pid } = router.query;

    useEffect(() => {
        if (pid) {
            router.replace(`/auth/register/${pid}`);
        }
    }, [pid, router]);

    return <div>Yuklanmoqda...</div>;
};

export default RegisterRefPage;

